import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyAdjusterImagesTabsQueryParamsType,
  GetBodyAdjusterImagesTabsQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyDamagedAdjusterImagesTabs/getBodyDamagedAdjusterImagesTabs.type';

export const getBodyAdjusterImagesTabsQueryFunction = (
  params: GetBodyAdjusterImagesTabsQueryParamsType,
): Promise<GetBodyAdjusterImagesTabsQueryResponseType> => {
  return fetchApi.get(`/body/reports/${params.id}/images/adjuster/entry_tabs/`);
};
